import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import BvBtn from 'volta/components/bv-btn';
import BvModal from 'volta/components/bv-modal';
import BvTextContainer from 'volta/components/bv-text-container';

import type { TOC } from '@ember/component/template-only';

interface ConfirmDeleteModalSignature {
  Args: {
    deleteButtonText?: string;
    isLoading?: boolean;
    onCancel?: () => void;
    onDelete?: () => void;
    name?: string;
    title?: string;
  };
  Blocks: {
    default: [];
  };
}

const ConfirmDeleteModalComponent: TOC<ConfirmDeleteModalSignature> = <template>
  <BvModal @dialog={{true}} @size='sm' @onClose={{@onCancel}} as |modal|>
    <modal.Header
      @title={{or @title (if @name (t 'bvList.singleActions.confirmDeleteTitle' name=@name))}}
    />

      <modal.Body @sectioned={{true}}>
        <BvTextContainer>
          {{#if (has-block)}}
            {{yield}}
          {{else if @name}}
            {{t 'bvList.singleActions.confirmDelete' name=@name}}
          {{/if}}
        </BvTextContainer>
      </modal.Body>

    <modal.Footer>
      <BvBtn @text={{t 'cancel'}} @onClick={{@onCancel}} @testName='cancel-delete-button' />
      <BvBtn
        @text={{or @deleteButtonText (t 'delete')}}
        @color='danger'
        @onClick={{optional @onDelete}}
        @isLoading={{@isLoading}}
        @testName='confirm-delete-button'
      />
    </modal.Footer>
  </BvModal>
</template>;

export default ConfirmDeleteModalComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ConfirmDeleteModal: typeof ConfirmDeleteModalComponent;
    'confirm-delete-modal': typeof ConfirmDeleteModalComponent;
  }
}
